import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { CheckCircleIcon, Key } from 'lucide-react';
import { QrCode2 } from '@mui/icons-material';
import { ClearIcon } from '@mui/x-date-pickers';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import driver from '../../delivery-company-components/driver/driver';
import { DriverType } from '../../../interfaces/delivery-company/drivers';
import { WhatsAppConnectionAuthCode } from '../../common/whatsapp-auth-code/whatsapp-auth-code';

function WhatsappConnection() {
  const { user, refreshUser, config } = useContext(AuthContext);
  const [gettingAuthCode, setGettingAuthCode] = useState(false);

  useEffect(() => {
    refreshUser();
  }, []);

  const handleHelpClick = () => {
    window.open('https://wa.me/33753560667', '_blank');
  };

  return (
    <div>
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 2 }}
        >
          WhatsApp Connection
        </Typography>

        {user && (
          <>
            {user.connected_to_whatsapp == undefined && <CircularProgress />}

            <div style={{ width: '100%', textAlign: 'center' }}>
              {user.connected_to_whatsapp ? (
                <Chip
                  icon={<CheckCircleIcon />}
                  color="success"
                  label="Connected To WhatsApp"
                />
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ textAlign: 'center', margin: 10 }}>
                    Connect using PIN Code <br />
                    <IconButton onClick={() => setGettingAuthCode(true)}>
                      <Key fontSize={'large'} />
                    </IconButton>
                  </div>
                </div>
              )}
              <br /> <br />
            </div>

            {/* Helper Section */}
            <Alert severity="success" sx={{ mb: 2 }} icon={false}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Connect your WhatsApp account to automate sending customer
                notifications from your own phone number. You can disconnect at
                any time through the WhatsApp app settings.
              </Typography>
              <Typography variant="body1" dir="rtl" textAlign="right">
                قم بربط حساب الواتساب الخاص بك لإرسال إشعارات العملاء بشكل
                تلقائي من رقم هاتفك. يمكنك فصل الاتصال في أي وقت من إعدادات
                تطبيق الواتساب.
              </Typography>

              <br />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleHelpClick}
                >
                  Help
                </Button>
              </div>
            </Alert>
          </>
        )}
      </Box>

      {user && gettingAuthCode && (
        <CustomDialog
          open={gettingAuthCode}
          onClose={() => setGettingAuthCode(false)}
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <DialogTitle>Connecting to WhatsApp</DialogTitle>
            <IconButton
              onClick={() => {
                setGettingAuthCode(false);
              }}
            >
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            <WhatsAppConnectionAuthCode
              driver={
                {
                  id: user.id.toString(),
                  name: user.name,
                  phone_number: user.phone_number,
                } as DriverType
              }
            />
          </DialogContent>
        </CustomDialog>
      )}
    </div>
  );
}

export default WhatsappConnection;
